import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { ERoutes } from '../../routes';
import { ApplicationState } from '../../store';
import FabricationOrders from './FabricationOrders';
import LongSteelOrders from './LongSteelOrders';
import SteelTypeChoose from './SteelTypeChoose';

export enum EOrdersRoutes {
  STEEL_TYPE_CHOOSE = 'steel-type-choose',
  LONG_STEEL_ORDERS = 'long-steel',
  FABRICATION_ORDERS = 'fabrication' // corte e dobra
}

const OrdersRoutes: React.FC = () => {
  const path = `${ERoutes.ORDERS}`;

  const hasUserFabricationAccess = useSelector(
    (appState: ApplicationState) =>
      appState.user.userPermissions.hasFabricationAccess
  );

  return (
    <>
      {hasUserFabricationAccess && (
        <>
          <Route path={`${path}/`} exact>
            <Redirect to={`${path}/${EOrdersRoutes.STEEL_TYPE_CHOOSE}`} />
          </Route>

          <Route
            path={`${path}/${EOrdersRoutes.STEEL_TYPE_CHOOSE}`}
            component={SteelTypeChoose}
          />

          <Route
            path={`${path}/${EOrdersRoutes.FABRICATION_ORDERS}`}
            component={FabricationOrders}
          />
        </>
      )}

      {!hasUserFabricationAccess && (
        <>
          <Redirect to={`${path}`} />

          <Route path={`${path}/`} exact>
            <Redirect to={`${path}/${EOrdersRoutes.LONG_STEEL_ORDERS}`} />
          </Route>
        </>
      )}

      <Route
        path={`${path}/${EOrdersRoutes.LONG_STEEL_ORDERS}`}
        component={LongSteelOrders}
      />
    </>
  );
};

export default OrdersRoutes;
